import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Create an Emotion cache
const emotionCache = createCache({
  key: 'emotion-cache',
});

// Wrap the root element with the Emotion CacheProvider
export const wrapRootElement = ({ element }) => (
  <CacheProvider value={emotionCache}>
    {element}
  </CacheProvider>
);

// Handle language redirect on initial client render
export const onInitialClientRender = () => {
  // Only run on the index page
  if (typeof window !== 'undefined' && window.location.pathname === '/') {
    // Get the browser language
    const browserLang = navigator.language || navigator.userLanguage;

    // Check if the browser language starts with 'de'
    const isGerman = browserLang.toLowerCase().startsWith('de');

    // Redirect to the appropriate language page with trailing slash
    window.location.replace(isGerman ? '/de/' : '/en/');
  }
};
